import _default from './Message';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Message/index.js
// module id = 1747
// module chunks = 0